import Root from './styled-components/Root';
import { createDivider } from '@gluestack-ui/divider';
export const Divider = createDivider({ Root });
